// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/organisations/organisations.scss
 ** module id = 137
 ** module chunks = 0 1
 **/